import React, { useState } from 'react'

function GroupPostInfoModal() {
    const [open, setOpen] = useState(false)

    const openModal = () => {
        setOpen(true)
    }

    const cancel = () => {
        setOpen(false)
    }

  return (
    <div>
        <small className="form-text info-question-position-two" onClick={openModal}>
            Learn more about multiple posts<i className="fas fa-question-circle mr-2 text-secondary-icon cursor-cu"></i>
        </small>

         {open &&
            <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center">
                <div>
                    <h5><strong>Scaling Effectively with Multiple Posts</strong></h5>
                    <div>
                        <p className="cu-template-info">
                            Creating multiple posts just got much easier! <br/> You can now create up to 500 posts without having to go <br/>
                            to each users profile. This allows you to upload and create content in a seemless manner, with minimal work to speed up the process. <br/>
                        <div className='list-modal-group'><b>In this form:</b></div>
                         <ul className='list-modal-group-items'>  
                            <i>You can select and remove media files for the particular post at the bottom of the page.<br/></i>
                            <i>Edit media files with the drop-down "Edit Media Files" button (if you choose to use media).<br/></i>
                            <i>Select who you are creating the post for and who their audience will be.<br/></i>
                            <i>Use templates from the suggested templates when typing content into a post.<br/></i>
                            <i>Use template variables by typing two curly braces {'"{{"'} in the text areas.<br/></i>
                            <i>Move to the next post by clicking "Next".<br/></i>
                            <i>It you need a break, click "Continue Later" - you will always be able to access the pending post from the dashboard.<br/></i>
                        </ul> 
                        </p>
                        <p className="cu-template-info">
                            <i><b>NOTE:</b>You can always edit an individual post from the Multiple Post List if you make a mistake.</i>
                        </p>
                    </div>
                </div>

                    <div className="pt-3">
                        <button onClick={cancel} type="button" className="btn btn-primary mr-2">
                            Close
                        </button>
                    </div>
                </div>
         </div>}
    </div>
  )
}

export default GroupPostInfoModal